import React from 'react';
import ReactDOM from 'react-dom';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import LaboratoryResults from './LaboratoryResults';

loadDOMComponent({
	selector: 'react-laboratory-results',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<LaboratoryResults />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
